// @flow
// in src/posts.js
import React from "react";
import { Show, SimpleShowLayout, TextField, DateField, ImageField } from "react-admin";

const VideoShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="name" label="Название" />
      <TextField source="description" label="Описание" />
      <TextField source="videoId" name="videoId" />
      <TextField source="link" />
      <ImageField source="previews.m.link" />
      <DateField label="Дата создания" source="createdAt" />
      <DateField label="Дата редактирования" source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);

export default VideoShow;
